module.exports = __webpack_public_path__ + "img/translate-thirteen.fda93862.png";